// extracted by mini-css-extract-plugin
export var addressFields = "_nn-0";
export var animationContainer = "_nn-1";
export var footer = "_nn-2";
export var lineItems = "_nn-3";
export var modalContent = "_nn-4";
export var orderName = "_nn-5";
export var strong = "_nn-6";
export var warning = "_nn-7";